"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Criteo = void 0;
const tslib_1 = require("tslib");
const criteo_1 = tslib_1.__importDefault(require("./criteo"));
exports.Criteo = criteo_1.default;
//# sourceMappingURL=index.js.map